import { SectionWrapper } from '../section-wrapper'
import { CountriesViewsTable } from './countries-table'
import { useAccountCountriesViews } from 'src/hooks'

import { HelperWrapper } from 'src/components/helper-wrapper'
const CountriesViews = () => {
  const { data } = useAccountCountriesViews()

  return (
    <SectionWrapper title={<HelperWrapper t="dashboard-countries-views-title" />}>
      <CountriesViewsTable rows={data || null} />
    </SectionWrapper>
  )
}

export { CountriesViews }
